var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubdirectoryArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_740_8489",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_740_8489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.473 19.9578C13.318 19.8026 13.2421 19.6253 13.2453 19.426C13.2484 19.2267 13.3243 19.0526 13.473 18.9038L16.627 15.75H7.30775C6.80908 15.75 6.38308 15.5734 6.02975 15.2203C5.67658 14.8669 5.5 14.4409 5.5 13.9423V5.25C5.5 5.03717 5.57183 4.859 5.7155 4.7155C5.859 4.57183 6.03717 4.5 6.25 4.5C6.46283 4.5 6.641 4.57183 6.7845 4.7155C6.92817 4.859 7 5.03717 7 5.25V13.9423C7 14.0321 7.02883 14.1058 7.0865 14.1635C7.14417 14.2212 7.21792 14.25 7.30775 14.25H16.627L13.4577 11.0807C13.3026 10.9256 13.2276 10.7499 13.2327 10.5538C13.2379 10.3578 13.3129 10.1822 13.4577 10.027C13.6129 9.87183 13.7902 9.79333 13.9895 9.7915C14.1888 9.7895 14.3628 9.86283 14.5115 10.0115L18.8673 14.3673C18.9609 14.4609 19.0269 14.5597 19.0652 14.6635C19.1037 14.7673 19.123 14.8795 19.123 15C19.123 15.1205 19.1037 15.2327 19.0652 15.3365C19.0269 15.4403 18.9609 15.5391 18.8673 15.6328L14.5423 19.9578C14.3871 20.1128 14.2089 20.1902 14.0078 20.1902C13.8064 20.1902 13.6282 20.1128 13.473 19.9578Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubdirectoryArrowRight);
export default __webpack_public_path__ + "static/media/subdirectory_arrow_right.c63ace36f132913b4fafab385151750e.svg";
export { ForwardRef as ReactComponent };